import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';


export interface ImageGalleryProps {
	imageList?: Array<any>;
}

export default class ImageGallery extends React.Component<ImageGalleryProps, any> {
	constructor(props) {
		super(props);
		this.state = {
			showKey : 0,
		}
	}
	static propTypes = {
		imageList: PropTypes.array.isRequired,
	};
	handleImgClick(iamgeIndex){
		this.setState({
			showKey: iamgeIndex,
		})
	}
	render(){
		const {showKey} = this.state;
		const {imageList} = this.props;
		return(
			<div className="image-gallery" >
				<ul className="image-preview">
					{imageList && imageList.map((item, index)=>{
						return (<li className='preview-item' key={item.toString()}>
							<img className={classNames({'img-onclick': index === showKey})}src={item} onClick={this.handleImgClick.bind(this, index)}/>
						</li>)
					})}
				</ul>
				<div className="image-display">
					<img src={imageList && imageList[showKey]} />
				</div>
			</div>
		);
	}	
}


// WEBPACK FOOTER //
// ./components/image-gallery/index.tsx